// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error{color:red;margin-top:10px}.ldr{position:relative}", ""]);
// Exports
module.exports = exports;
